export default __webpack_public_path__ + "static/media/blog.1ce44230.jpg";